import React from "react";
import FieldConfig from "../../proto/field-config";
import FieldProto from "../../proto/field-proto";
import FieldEvent_View from "./render/view";
import Task from "../../../model2/task/task";

export default class FieldEvent extends FieldProto {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Event";

        this.renderComponents.view          = FieldEvent_View
        this.renderComponents.viewSmall     = FieldEvent_View
        this.renderComponents.viewReference = FieldEvent_View
        this.renderComponents.glistView     = FieldEvent_View
    }


    // normalize value for sorting
    sortValue(value:Task, model?:any) {
        return value ? value.name.toLowerCase() : ''
    }
}